import { render, staticRenderFns } from "./WalletScreen.vue?vue&type=template&id=1cb66ce6&scoped=true"
import script from "./WalletScreen.vue?vue&type=script&lang=js"
export * from "./WalletScreen.vue?vue&type=script&lang=js"
import style0 from "./WalletScreen.vue?vue&type=style&index=0&id=1cb66ce6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb66ce6",
  null
  
)

export default component.exports